import { toFolder } from '../mappers/folder';
export function parseFolders() {
  return {
    data: [toFolder()]
  };
}